import {
  Action,
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store, { StoreManager } from "@/store";
import API from "../api";
import router from "@/router";
import { IUserData } from "@/interfaces/userdata.interface";
import { IOrganization } from "@/interfaces/organization.interface";
import { PUBLIC_PATH } from "@/config"

@Module({
  dynamic: true,
  namespaced: true,
  name: "user",
  store
})
export class UserModule extends VuexModule {
  isLoggedIn: boolean | null = null;
  userData: IUserData | null = null;
  organization: IOrganization | null = null;

  @Mutation
  async reset() {
    this.isLoggedIn = null;
    this.userData = null;
  }

  @MutationAction
  async setLoggedInStatus(isLoggedIn: boolean) {
    return {
      isLoggedIn
    };
  }

  @MutationAction
  async setUserData(userData: IUserData) {
    return {
      userData
    };
  }

  @Action
  async testLogin() {
    if (this.isLoggedIn != null) {
      return this.isLoggedIn;
    }
    const loginStatus = await this.loginWithoutUsername();
    this.setLoggedInStatus(loginStatus);
    return loginStatus;
  }

  @Action
  async login({ username, password }: { username: string; password: string }) {
    try {
      const userData: IUserData = await API.loginRequest(username, password);
      await this.setLoggedInStatus(true);
      await this.setUserData(userData);
      await this.refreshOwnOrganization();
      return true;
    } catch (e) {
      return false;
    }
  }

  @Action
  async loginWithoutUsername() {
    try {
      const userData: IUserData = await API.loginRequestWithoutAuthentication();
      await this.setLoggedInStatus(true);
      await this.setUserData(userData);
      await this.refreshOwnOrganization();
      return true;
    } catch (e) {
      return false;
    }
  }

  @Action
  async logout() {
    await API.logoutRequest();
    StoreManager.reset();
    await router.push({ path: PUBLIC_PATH + "/login" });
  }

  @MutationAction
  async refreshOwnOrganization() {
    const organization = await API.getOwnOrganization();
    return {
      organization
    };
  }

  @MutationAction
  async updateOrganization(organization: IOrganization) {
    const updatedOrganization = await API.updateOwnOrganization(organization);
    return {
      organization: updatedOrganization
    };
  }
}

const userModule = getModule(UserModule);

export default userModule;

export function userHasRole(specificRole: string): boolean {
  if (userModule.userData) {
    if (userModule.userData.roles.includes(specificRole)) {
      return true;
    }
  }
  return false;
}
export function userHasPrivilege(specificPrivilege: string): boolean {
  if (userModule.userData) {
    if (userModule.userData.privileges.includes(specificPrivilege)) {
      return true;
    }
  }
  return false;
}
